import axios from 'axios';

const urlEndpoint = process.env.REACT_APP_FISH_BE_ENDPOINT;

const api = axios.create({
  baseURL: urlEndpoint,
  headers: {
    'Content-Type': 'application/json',
  },
});

api.interceptors.request.use(
  async (config) => {
    const token = localStorage.getItem('fishAuth');
    if (token) {
      config.headers.authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    console.log({ error });
    Promise.reject(error);
  }
);

api.interceptors.response.use(
  (response) => {
    return response;
  },
  (err) => {
    const error = (err.response && err.response.data) || err.message;
    throw error;
  }
);

export default api;
